// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","header":"AssetCategory_header__Tsv20","assets":"AssetCategory_assets__3juZ1"};